














import Vue from 'vue';
import { kebabCase, get } from 'lodash';
import { objectStatusColor } from '@/utils';

const statusFilter = (props: object): string => {
  let objType = get(props, 'row.__typename', '');
  let status = get(props, 'data.value', '');
  return objType.toLowerCase() === 'issue'
    ? `badge status-issue-${kebabCase(status)}`
    : `badge badge-${objectStatusColor(status) || 'light'}`;
};

export default Vue.extend({
  name: 'StatusCellPresenter',
  filters: {
    statusFilter,
  },
});
